<script setup lang="ts">
import PlanFeature from './PlanFeature.vue';

const props = withDefaults(
    defineProps<{
        features: string[];
        size?: 'sm' | 'md';
    }>(),
    {
        size: 'md'
    }
);
</script>

<template>
    <ul
        class="features-container space-y-2 pl-0"
        :class="props.size === 'sm' ? 'text-sm' : 'text-base'"
    >
        <PlanFeature
            v-for="feature in props.features"
            :key="feature"
            :feature="feature"
        />
    </ul>
</template>
